import React from "react";
import { Keyframes, animated } from "react-spring/renderprops";
import "./App.css";
import Nubes from "../../assets/images/nubes.png";

const defaultStyles = {
  overflow: "hidden",
  color: "black",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export default class Box extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      items: [""],
      delay: 0,
      duration: 180000,
      ref: React.createRef(),
    };
  }

  render() {
    let top = "30%";
    if (window.innerWidth < 480) {
      top = "40%";
    }
    var Content = Keyframes.Spring(async (next) => {
      // None of this will cause React to render, the component renders only once :-)
      await next({
        from: {
          position: "absolute",
          zIndex: 10,
          left: "50%",
          width: "60%",
          opacity: 1,
          top: top,
          padding: 0,
        },
      });
      await next({
        left: "-50%",
        config: { duration: this.state.duration, delay: this.state.delay },
      });
    });
    return (
      <Content native>
        {(props) => (
          <animated.div
            style={{ position: "absolute", ...defaultStyles, ...props }}
          >
            <img src={Nubes} className="nubes" alt="background" />
          </animated.div>
        )}
      </Content>
    );
  }
}
